import api from './api';

const CUSTOMER_MASTER_BASE_URL = '/customer-master';

const customerMasterService = {
  // Get all customers with pagination and search
  getAllCustomers: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.category) queryParams.append('category', params.category);
      if (params.region) queryParams.append('region', params.region);
      if (params.status) queryParams.append('status', params.status);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

      const response = await api.get(`${CUSTOMER_MASTER_BASE_URL}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customers:', error);
      throw error;
    }
  },

  // Get customer by ID
  getCustomerById: async (id) => {
    try {
      const response = await api.get(`${CUSTOMER_MASTER_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customer:', error);
      throw error;
    }
  },

  // Create new customer
  createCustomer: async (customerData) => {
    try {
      const response = await api.post(CUSTOMER_MASTER_BASE_URL, customerData);
      return response.data;
    } catch (error) {
      console.error('Error creating customer:', error);
      throw error;
    }
  },

  // Update customer
  updateCustomer: async (id, customerData) => {
    try {
      // Validate ID before making the request
      if (!id || id === 'undefined' || id === 'null') {
        const error = new Error('Customer ID is required for update');
        error.name = 'ValidationError';
        throw error;
      }
      
      const response = await api.put(`${CUSTOMER_MASTER_BASE_URL}/${id}`, customerData);
      return response.data;
    } catch (error) {
      console.error('Error updating customer:', error);
      throw error;
    }
  },

  // Delete customer
  deleteCustomer: async (id) => {
    try {
      const response = await api.delete(`${CUSTOMER_MASTER_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting customer:', error);
      throw error;
    }
  },

  // Get customer statistics
  getCustomerStats: async () => {
    try {
      const response = await api.get(`${CUSTOMER_MASTER_BASE_URL}/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customer stats:', error);
      throw error;
    }
  },

  // Get active customers
  getActiveCustomers: async () => {
    try {
      const response = await api.get(`${CUSTOMER_MASTER_BASE_URL}/active`);
      return response.data;
    } catch (error) {
      console.error('Error fetching active customers:', error);
      throw error;
    }
  },

  // Get customers by category
  getCustomersByCategory: async (category) => {
    try {
      const response = await api.get(`${CUSTOMER_MASTER_BASE_URL}/category/${category}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customers by category:', error);
      throw error;
    }
  },

  // Get customers by region
  getCustomersByRegion: async (region) => {
    try {
      const response = await api.get(`${CUSTOMER_MASTER_BASE_URL}/region/${region}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customers by region:', error);
      throw error;
    }
  }
};

export default customerMasterService;
